export default {
    name: 'guest',
    generalData: 'generalData',
    guestEnabled: 'guestEnabled',
    guestOccupation: 'guestOccupation',
    products: 'products',
    submittalOptions: 'submittalOptions',
};
